module.exports = __webpack_public_path__ + "static/images/settings-sliders-48-full.6546ef2ed7c04c7c224d5bbc7170bf9f.svg";